<template>
    <Title_Base :icon="icon" :title="text">
        <template v-if="!loading && item" v-slot:title>
            <!-- 
            <QTextField v-model="item.Name" :label="'Name'" singleline :rules="[requiredRule]" style="width: 500px;">
            </QTextField>
            -->
            <v-text-field v-model="changeControlledText" :loading="setLoading" class="py-0 my-0" hide-details
                style="width: 480px;" :counter="50" maxlength="50" @input="debounceSet(item)" @blur="set(item)"
                @keypress.enter="set(item)">
            </v-text-field>
        </template>
    </Title_Base>
</template>


<script>
import ClientAPIMixin from "@/api/ClientAPIMixin";
import Title_Base from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Base.vue";
import { debounce } from "debounce";
import EntityNames from "@/helpers/Constants/EntityNames";

export default {
    name: 'Title_JobCategory',
    props: {},
    components: {
        Title_Base,
    },
    mixins: [ClientAPIMixin],

    data() {
        return {
            entityName: EntityNames.JobCategory,
            setLoading: false,
        };
    },

    methods: {
        set() {
            var newText = this.item.newName;
            var isChanged = newText && (newText != this.item.Name);
            if (!isChanged) {
                return;
            }
            else {
                this.setLoading = true;
                this.item.Name = `${this.item.newName}`;
                this.item.newName = ``;

                this.changeJobCategory(this.item)
                    .finally(() => {
                        this.setLoading = false;
                    });
            }
        },

        debounceSet: debounce(async function () {
            this.set();
        }, 700),
    },

    computed: {
        icon() {
            return "$job_categories";
        },

        changeControlledText: {
            get() {
                return this.item.newName ? this.item.newName : this.item.Name;
            },
            set(value) {
                this.item.newName = value;
            }
        },

        text() {
            if (this.loading || !this.item) {
                return this.$t('servicesystem.common_objects.commonterms.loading_placeholder', { pkey: this.$t('servicesystem.common_objects.job.job_category') });
            }
            else {
                return `${this.item.Name}`;
            }
        },

        item() {
            return this.$store.getters["entitycontainerstore/getEntity"](this.entityName);
        },

        loading() {
            return this.$store.getters["entitycontainerstore/getEntityLoading"](this.entityName);
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>